// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// Hooks
import { addListenerForPushNotificationRegistration } from '../../notifications/push/mobileNotificationsUtils';

// Constants
import { CAPACITOR_NOTIFICATIONS_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

// Plugins
import { NotificationsPlugin } from '../../../capacitor_plugins/notifications';

export default function () {
    useEffect(() => {
        (async () => {
            await addListenerForPushNotificationRegistration();

            if (Capacitor.isPluginAvailable(CAPACITOR_NOTIFICATIONS_PLUGIN)) {
                NotificationsPlugin.registerPushNotificationsOnDevice();
            }
        })();
    }, []);
}
